


























import {Component, Vue} from 'vue-property-decorator';
import ReportContainer from '../../components/report-container/report-container.vue';
import FilterContainer from '../../components/filter-container/filter-container.vue';
import ReportPlaceHolder from '../../components/report-placeholder/report.placeholder.vue';
import ReportVueContainer from '../../components/report-vue-container/report-vue-container.vue';
import FilterDropDown from '../../components/filter-form/filter-drop-down/filterDropDown.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import {FormFilterFields} from '../../model/types/interfaces/FormFilterFields';
import RegistrationBrandSegmentFilter
  from '@/modules/neodash/pages/registrationByBrandAndSegment/registration-brand-segment.filter.vue';
import RegistrationByBrandReport
  from '@/modules/neodash/pages/registrationByBrandAndSegment/registration-by-brand.report.vue';
import RegistrationInSegmentReport
  from '@/modules/neodash/pages/registrationByBrandAndSegment/registration-in-segment.report.vue';
import {Filters} from '@/modules/neodash/pages/registrationByBrandAndSegment/Filters';
import {BrandSegmentReportContextEnum} from '@/enums/brand-segment-report-context.enum';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';

@Component({
  name: 'RegistrationByBrandAndSegment',
  components: {
    RegistrationInSegmentReport,
    RegistrationByBrandReport,
    RegistrationBrandSegmentFilter,
    ReportVueContainer,
    ReportPlaceHolder, PageLoader, FilterDropDown, FilterContainer, ReportContainer
  }
})

export default class RegistrationByBrandAndSegment extends Vue {
  public readonly keyLabelComparisonBasketReport: string = 'Report.RegistrationByBrandAndSegment';
  public dataQuery = {} as any;
  public filters: FormFilterFields<Filters> = {
    value: {} as Filters,
    labels: []
  } as FormFilterFields<Filters>;


  public get showInSegmentReport() {
    return !!this.filters.value && this.getReportContext() === BrandSegmentReportContextEnum.inSegment;
  }

  public get showByBrandReport() {
    return !!this.filters.value && this.getReportContext() === BrandSegmentReportContextEnum.byBrand;
  }

  getReportContext(): BrandSegmentReportContextEnum {
    const {dsRegistrationReportContext} = this.filters.value;
    return !!dsRegistrationReportContext ? dsRegistrationReportContext.value : BrandSegmentReportContextEnum.default
  }

  public get labels() {
    const {labels} = this.filters;
    return labels;
  }

  public showReport() {
    const filters = this.filters.value;
    const {chosenPeriod} = filters;
    let initialDate = new Date();
    let endDate = new Date();
    if (!!chosenPeriod) {
      initialDate = new Date(chosenPeriod.value.dtYearInit, chosenPeriod.value.dtMonthInit - 1);
      endDate = new Date(chosenPeriod.value.dtYearFinal, chosenPeriod.value.dtMonthFinal - 1);
    }
    this.dataQuery = {
      resolutionLevel: {
        name: '',
        value: !!filters.calculatedLocalityLevelAndType ? [filters.calculatedLocalityLevelAndType.resolutionLevel] : []
      },
      ano: {name: '', value: !!filters.chosenPeriod ? filters.chosenPeriod.value.dtYearInit : null},
      mes_inicial: {name: initialDate.toLocaleString('default', {month: 'long'}), value: initialDate.getMonth() + 1},
      mes_final: {name: endDate.toLocaleString('default', {month: 'long'}), value: endDate.getMonth() + 1},
      localidades: {text: filters.localities.map(x => x.name), value: filters.localities.map(x => x.value)},
      virtualAreaType: {
        name: '',
        value: !!filters.calculatedLocalityLevelAndType ? [filters.calculatedLocalityLevelAndType.virtualAreaType] : []
      },
      tipo_emplacamento: {name: '', value: !!filters.chosenLicensePlate ? filters.chosenLicensePlate.value : null},
      idsCompanySize: {
        text: filters.companySizes.map(x => x.name),
        value: filters.companySizes.map(x => x.value),
      },
    }

    traceLogAccess.logAction(ContextEnum.Report, `Emplacamento Bandeira | Segmento - Filtro`, JSON.stringify(this.dataQuery));
  };
}
